import { render } from "./RecordImage.vue?vue&type=template&id=5fb722cb"
import script from "./RecordImage.vue?vue&type=script&lang=js"
export * from "./RecordImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__